export default [
  {
    path: '/app/corporate-policies',
    name: 'CorporatePolicies',
    component: () => import('@/views/Admin/Corporate_policies/Index.vue'),
    meta: {
      pageTitle: 'Kurumsal Sosyal Sorumluluk',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_CORPORATE_POLICIES',
      action: 'read',
    },
  },
  {
    path: '/app/corporate-policies/add',
    name: 'CorporatePoliciesAdd',
    component: () => import('@/views/Admin/Corporate_policies/Add.vue'),
    meta: {
      pageTitle: 'Kurumsal Sosyal Sorumluluk',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/corporate-policies',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_CORPORATE_POLICIES',
      action: 'read',
    },
  },
  {
    path: '/app/corporate-policies/edit/:id',
    name: 'CorporatePoliciesEdit',
    component: () => import('@/views/Admin/Corporate_policies/Edit.vue'),
    meta: {
      pageTitle: 'Kurumsal Sosyal Sorumluluk',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/corporate-policies',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_CORPORATE_POLICIES',
      action: 'read',
    },
  },
]
